// extracted by mini-css-extract-plugin
export default {"departments":"LF-z","departmentHeading":"MF-z","departmentSection":"NF-z","departmentName":"OF-z","departmentLink":"PF-z","expandIcon":"QF-z"};